/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { useGlobal } from '@/store'
import { Service, ServicePackage } from '@/types/ServicePackage'

export default class ServicePackageRequest {
  groupCk: string
  classId: string
  classPlanId: string
  showEye360: boolean
  servicePackages: {
    packageNumber: number,
    packageName: string,
    services: (Service & {
      lineNumber: number,
      units: number
    })[]
  }[]

  constructor (servicePackages: ServicePackage[], showEye360 = false) {
    const { groupCk, classId, classPlanId } = useGlobal()
    this.groupCk = groupCk
    this.classId = classId
    this.classPlanId = classPlanId
    this.showEye360 = showEye360
    this.servicePackages = servicePackages.map(({ packageName, services }, index) => ({
      packageNumber: index + 1,
      packageName,
      services: services.map(({ procedureCode, charges }, index) => ({
        lineNumber: index,
        procedureCode,
        charges,
        units: 1
      }))
    }))
  }

  public static of (servicePackages: ServicePackage[], showEye360 = false) {
    return new ServicePackageRequest(servicePackages, showEye360)
  }
}
